module.exports = __webpack_public_path__ + "img/q11.30a13273.png";